 export function useExport(data) {
  const exportToCSV = () => {
    const csv = data.map((row) => Object.values(row).join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "sales.csv";
    link.click();
  };

  return { exportToCSV };
}
